"use strict";

var Backbone = require("backbone");

// require à faire une fois

/**
 * ajoute un racourci pour la syntaxe setElement un peu pénible
 * @param  {[type]} view     [description]
 * @param  {[type]} selector [description]
 * @return {[type]}          [description]
 */
Backbone.View.prototype.assign = function(view, selector) {
   view.setElement(this.$(selector)).render();
   return this;
};


/**
 * modification history pour gérer correctement les %20 et les accentués : sans cette modification cela provoque des appels au router même si on fait trigger:false
 * buggé dans la v1.3.3 et plus mis à jour apparement
 * https://github.com/jashkenas/backbone/issues/4025
 */
// Checks the current URL to see if it has changed, and if it has,
// calls `loadUrl`, normalizing across the hidden iframe.
Backbone.history.checkUrl=function(/*e*/) {
    var T=Backbone.history;
    var current = T.getFragment();

    // If the user pressed the back button, the iframe's hash will have
    // changed and we should use that for comparison.
    if (current === T.fragment && T.iframe) {
    current = T.getHash(T.iframe.contentWindow);
    }

    // immanens
    current=T.decodeFragment(current.replace(Backbone.History.pathStripper, ''));

    if (current === T.fragment) return false;
    if (T.iframe) T.navigate(current);
    T.loadUrl();
};

// Save a fragment into the hash history, or replace the URL state if the
// 'replace' option is passed. You are responsible for properly URL-encoding
// the fragment in advance.
//
// The options object can contain `trigger: true` if you wish to have the
// route callback be fired (not usually desirable), or `replace: true`, if
// you wish to modify the current URL without adding an entry to the history.
Backbone.history.navigate=function(fragment, options) {
    if (!Backbone.History.started) return false;
    if (!options || options === true) options = {trigger: !!options};

    // Normalize the fragment.
    fragment = this.getFragment(fragment || '');

    // Don't include a trailing slash on the root.
    var rootPath = this.root;
    if (fragment === '' || fragment.charAt(0) === '?') {
    rootPath = rootPath.slice(0, -1) || '/';
    }
    var url = rootPath + fragment;

    // Strip the hash and decode for matching.
    // immanens
    // https://github.com/jashkenas/backbone/pull/4026/files
    fragment = fragment.replace(Backbone.History.pathStripper, '');

    // Decode for matching.
    var decodedFragment = this.decodeFragment(fragment);

    if (this.fragment === decodedFragment) return;
    this.fragment = decodedFragment;

    // If pushState is available, we use it to set the fragment as a real URL.
    if (this._usePushState) {
    this.history[options.replace ? 'replaceState' : 'pushState']({}, document.title, url);

    // If hash changes haven't been explicitly disabled, update the hash
    // fragment to store history.
    } else if (this._wantsHashChange) {
    this._updateHash(this.location, fragment, options.replace);
    if (this.iframe && fragment !== this.getHash(this.iframe.contentWindow)) {
        var iWindow = this.iframe.contentWindow;

        // Opening and closing the iframe tricks IE7 and earlier to push a
        // history entry on hash-tag change.  When replace is true, we don't
        // want this.
        if (!options.replace) {
        iWindow.document.open();
        iWindow.document.close();
        }

        this._updateHash(iWindow.location, fragment, options.replace);
    }

    // If you've told us that you explicitly don't want fallback hashchange-
    // based history, then `navigate` becomes a page refresh.
    } else {
    return this.location.assign(url);
    }
    if (options.trigger) return this.loadUrl(fragment);
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/@immanens-com/pv5js/common/utils/backbone-util.js
// module id = 75
// module chunks = 0